module.exports = __webpack_public_path__ + "01_glasses_black.e5815f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/01_glasses_black.png
// module id = HtZi
// module chunks = 0